jQuery(document).ready(function ($) {
    let lazyLoadInstance = new LazyLoad({
        elements_selector: '.lazy-load-image'
    });

    let headerMobileMenuIcon = $('.mobile-menu-icon-wrapper');
    headerMobileMenuIcon.on('click', function () {
        let header = $(this).closest('.header');
        let mobileMenu = header.siblings('.header-mobile-menu');
        header.toggleClass('mobile-menu-opened');
        mobileMenu.slideToggle(500);
    });

    let heroSliderDesktop = $('.hero-slider').slick({
        infinite: true,
        dots: true,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000
    });

    let servicesSlider = $('.services-list').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    $('.header .header__menu, .main, .footer').on('click', 'a', function (event) {
        let link = $(this).attr('href').split('#');

        if (link.length === 2) {
            let anchor = $('#' + link[1]);

            if (anchor.length) {
                event.preventDefault();
                let headerHeight = $('.header').outerHeight();
                let top = anchor.offset().top - headerHeight;
                $('body,html').animate({scrollTop: top}, 700);
            }
        }
    });

    $('.header-mobile-menu').on('click', 'a', function (event) {
        let link = $(this).attr('href').split('#');

        if (link.length === 2) {
            let anchor = $('#' + link[1]);

            if (anchor.length) {
                event.preventDefault();
                let headerHeight = $('.header').outerHeight();
                let top = anchor.offset().top - headerHeight;
                headerMobileMenuIcon.click();
                $('body,html').animate({scrollTop: top}, 700);
            }
        }
    });
});
